var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    width: 888,
    height: 888,
    viewBox: "0 0 888 888",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#ffffff"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(240,48) scale(4.12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6,5.5H3C1.6,5.5,0.5,4.4,0.5,3v0c0-1.4,1.1-2.5,2.5-2.5h3V5.5z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(264,48) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 6,
    height: 5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(288,48) scale(4.12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3,5.5H0v-5h3c1.4,0,2.5,1.1,2.5,2.5v0C5.5,4.4,4.4,5.5,3,5.5z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(360,48) scale(4.12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6,5.5H3C1.6,5.5,0.5,4.4,0.5,3v0c0-1.4,1.1-2.5,2.5-2.5h3V5.5z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(384,48) scale(4.12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3,5.5H0v-5h3c1.4,0,2.5,1.1,2.5,2.5v0C5.5,4.4,4.4,5.5,3,5.5z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(456,48) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 2.5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(600,48) scale(4.12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6,5.5H3C1.6,5.5,0.5,4.4,0.5,3v0c0-1.4,1.1-2.5,2.5-2.5h3V5.5z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(624,48) scale(4.12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3,5.5H0v-5h3c1.4,0,2.5,1.1,2.5,2.5v0C5.5,4.4,4.4,5.5,3,5.5z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(240,72) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 2.5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(288,72) scale(4.12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6,5.5H3C1.6,5.5,0.5,4.4,0.5,3v0c0-1.4,1.1-2.5,2.5-2.5h3V5.5z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(312,72) scale(4.12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3,5.5H0v-5h3c1.4,0,2.5,1.1,2.5,2.5v0C5.5,4.4,4.4,5.5,3,5.5z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(432,72) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 2.5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(504,72) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 2.5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(552,72) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 2.5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(624,72) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 2.5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(240,96) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 2.5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(312,96) scale(4.12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6,5.5H3C1.6,5.5,0.5,4.4,0.5,3v0c0-1.4,1.1-2.5,2.5-2.5h3V5.5z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(336,96) scale(4.12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3,5.5H0v-5h3c1.4,0,2.5,1.1,2.5,2.5v0C5.5,4.4,4.4,5.5,3,5.5z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(408,96) scale(4.12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6,5.5H3C1.6,5.5,0.5,4.4,0.5,3v0c0-1.4,1.1-2.5,2.5-2.5h3V5.5z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(432,96) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 6,
    height: 5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(456,96) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 6,
    height: 5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(480,96) scale(4.12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3,5.5H0v-5h3c1.4,0,2.5,1.1,2.5,2.5v0C5.5,4.4,4.4,5.5,3,5.5z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(552,96) scale(4.12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6,5.5H3C1.6,5.5,0.5,4.4,0.5,3v0c0-1.4,1.1-2.5,2.5-2.5h3V5.5z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(576,96) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 6,
    height: 5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(600,96) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 6,
    height: 5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(624,96) scale(4.12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3,5.5H0v-5h3c1.4,0,2.5,1.1,2.5,2.5v0C5.5,4.4,4.4,5.5,3,5.5z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(264,120) scale(4.12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6,5.5H3C1.6,5.5,0.5,4.4,0.5,3v0c0-1.4,1.1-2.5,2.5-2.5h3V5.5z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(288,120) scale(4.12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3,5.5H0v-5h3c1.4,0,2.5,1.1,2.5,2.5v0C5.5,4.4,4.4,5.5,3,5.5z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(336,120) scale(4.12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6,5.5H3C1.6,5.5,0.5,4.4,0.5,3v0c0-1.4,1.1-2.5,2.5-2.5h3V5.5z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(360,120) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 6,
    height: 5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(384,120) scale(4.12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3,5.5H0v-5h3c1.4,0,2.5,1.1,2.5,2.5v0C5.5,4.4,4.4,5.5,3,5.5z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(432,120) scale(4.12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6,5.5H3C1.6,5.5,0.5,4.4,0.5,3v0c0-1.4,1.1-2.5,2.5-2.5h3V5.5z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(456,120) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 6,
    height: 5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(480,120) scale(4.12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3,5.5H0v-5h3c1.4,0,2.5,1.1,2.5,2.5v0C5.5,4.4,4.4,5.5,3,5.5z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(600,120) scale(4.12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6,5.5H3C1.6,5.5,0.5,4.4,0.5,3v0c0-1.4,1.1-2.5,2.5-2.5h3V5.5z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(624,120) scale(4.12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3,5.5H0v-5h3c1.4,0,2.5,1.1,2.5,2.5v0C5.5,4.4,4.4,5.5,3,5.5z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(264,144) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 2.5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(312,144) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 2.5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(360,144) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 2.5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(408,144) scale(4.12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6,5.5H3C1.6,5.5,0.5,4.4,0.5,3v0c0-1.4,1.1-2.5,2.5-2.5h3V5.5z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(432,144) scale(4.12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3,5.5H0v-5h3c1.4,0,2.5,1.1,2.5,2.5v0C5.5,4.4,4.4,5.5,3,5.5z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(480,144) scale(4.12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6,5.5H3C1.6,5.5,0.5,4.4,0.5,3v0c0-1.4,1.1-2.5,2.5-2.5h3V5.5z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(504,144) scale(4.12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3,5.5H0v-5h3c1.4,0,2.5,1.1,2.5,2.5v0C5.5,4.4,4.4,5.5,3,5.5z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(240,168) scale(4.12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6,5.5H3C1.6,5.5,0.5,4.4,0.5,3v0c0-1.4,1.1-2.5,2.5-2.5h3V5.5z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(264,168) scale(4.12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3,5.5H0v-5h3c1.4,0,2.5,1.1,2.5,2.5v0C5.5,4.4,4.4,5.5,3,5.5z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(312,168) scale(4.12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6,5.5H3C1.6,5.5,0.5,4.4,0.5,3v0c0-1.4,1.1-2.5,2.5-2.5h3V5.5z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(336,168) scale(4.12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3,5.5H0v-5h3c1.4,0,2.5,1.1,2.5,2.5v0C5.5,4.4,4.4,5.5,3,5.5z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(432,168) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 2.5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(480,168) scale(4.12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6,5.5H3C1.6,5.5,0.5,4.4,0.5,3v0c0-1.4,1.1-2.5,2.5-2.5h3V5.5z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(504,168) scale(4.12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3,5.5H0v-5h3c1.4,0,2.5,1.1,2.5,2.5v0C5.5,4.4,4.4,5.5,3,5.5z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(576,168) scale(4.12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6,5.5H3C1.6,5.5,0.5,4.4,0.5,3v0c0-1.4,1.1-2.5,2.5-2.5h3V5.5z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(600,168) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 6,
    height: 5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(624,168) scale(4.12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3,5.5H0v-5h3c1.4,0,2.5,1.1,2.5,2.5v0C5.5,4.4,4.4,5.5,3,5.5z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(240,192) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 2.5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(288,192) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 2.5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(336,192) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 2.5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(384,192) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 2.5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(432,192) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 2.5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(480,192) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 2.5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(528,192) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 2.5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(576,192) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 2.5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(624,192) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 2.5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(240,216) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 2.5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(336,216) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 2.5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(432,216) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 2.5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(480,216) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 2.5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(552,216) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 2.5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(600,216) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 2.5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(96,240) scale(4.12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6,5.5H3C1.6,5.5,0.5,4.4,0.5,3v0c0-1.4,1.1-2.5,2.5-2.5h3V5.5z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(120,240) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 6,
    height: 5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(144,240) scale(4.12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3,5.5H0v-5h3c1.4,0,2.5,1.1,2.5,2.5v0C5.5,4.4,4.4,5.5,3,5.5z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(192,240) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 2.5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(240,240) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 2.5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(312,240) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 2.5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(360,240) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 2.5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(432,240) scale(4.12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6,5.5H3C1.6,5.5,0.5,4.4,0.5,3v0c0-1.4,1.1-2.5,2.5-2.5h3V5.5z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(456,240) scale(4.12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3,5.5H0v-5h3c1.4,0,2.5,1.1,2.5,2.5v0C5.5,4.4,4.4,5.5,3,5.5z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(504,240) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 2.5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(576,240) scale(4.12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6,5.5H3C1.6,5.5,0.5,4.4,0.5,3v0c0-1.4,1.1-2.5,2.5-2.5h3V5.5z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(600,240) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 6,
    height: 5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(624,240) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 6,
    height: 5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(648,240) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 6,
    height: 5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(672,240) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 6,
    height: 5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(696,240) scale(4.12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3,5.5H0v-5h3c1.4,0,2.5,1.1,2.5,2.5v0C5.5,4.4,4.4,5.5,3,5.5z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(768,240) scale(4.12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6,5.5H3C1.6,5.5,0.5,4.4,0.5,3v0c0-1.4,1.1-2.5,2.5-2.5h3V5.5z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(792,240) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 6,
    height: 5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(816,240) scale(4.12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3,5.5H0v-5h3c1.4,0,2.5,1.1,2.5,2.5v0C5.5,4.4,4.4,5.5,3,5.5z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(72,264) scale(4.12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6,5.5H3C1.6,5.5,0.5,4.4,0.5,3v0c0-1.4,1.1-2.5,2.5-2.5h3V5.5z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(96,264) scale(4.12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3,5.5H0v-5h3c1.4,0,2.5,1.1,2.5,2.5v0C5.5,4.4,4.4,5.5,3,5.5z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(168,264) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 2.5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(264,264) scale(4.12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6,5.5H3C1.6,5.5,0.5,4.4,0.5,3v0c0-1.4,1.1-2.5,2.5-2.5h3V5.5z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(288,264) scale(4.12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3,5.5H0v-5h3c1.4,0,2.5,1.1,2.5,2.5v0C5.5,4.4,4.4,5.5,3,5.5z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(336,264) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 2.5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(408,264) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 2.5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(456,264) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 2.5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(552,264) scale(4.12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6,5.5H3C1.6,5.5,0.5,4.4,0.5,3v0c0-1.4,1.1-2.5,2.5-2.5h3V5.5z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(576,264) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 6,
    height: 5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(600,264) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 6,
    height: 5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(624,264) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 6,
    height: 5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(648,264) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 6,
    height: 5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(672,264) scale(4.12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3,5.5H0v-5h3c1.4,0,2.5,1.1,2.5,2.5v0C5.5,4.4,4.4,5.5,3,5.5z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(768,264) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 2.5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(816,264) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 2.5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(72,288) scale(4.12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6,5.5H3C1.6,5.5,0.5,4.4,0.5,3v0c0-1.4,1.1-2.5,2.5-2.5h3V5.5z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(96,288) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 6,
    height: 5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(120,288) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 6,
    height: 5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(144,288) scale(4.12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3,5.5H0v-5h3c1.4,0,2.5,1.1,2.5,2.5v0C5.5,4.4,4.4,5.5,3,5.5z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(192,288) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 2.5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(336,288) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 2.5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(384,288) scale(4.12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6,5.5H3C1.6,5.5,0.5,4.4,0.5,3v0c0-1.4,1.1-2.5,2.5-2.5h3V5.5z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(408,288) scale(4.12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3,5.5H0v-5h3c1.4,0,2.5,1.1,2.5,2.5v0C5.5,4.4,4.4,5.5,3,5.5z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(456,288) scale(4.12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6,5.5H3C1.6,5.5,0.5,4.4,0.5,3v0c0-1.4,1.1-2.5,2.5-2.5h3V5.5z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(480,288) scale(4.12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3,5.5H0v-5h3c1.4,0,2.5,1.1,2.5,2.5v0C5.5,4.4,4.4,5.5,3,5.5z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(552,288) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 2.5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(648,288) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 2.5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(696,288) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 2.5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(744,288) scale(4.12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6,5.5H3C1.6,5.5,0.5,4.4,0.5,3v0c0-1.4,1.1-2.5,2.5-2.5h3V5.5z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(768,288) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 6,
    height: 5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(792,288) scale(4.12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3,5.5H0v-5h3c1.4,0,2.5,1.1,2.5,2.5v0C5.5,4.4,4.4,5.5,3,5.5z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(48,312) scale(4.12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6,5.5H3C1.6,5.5,0.5,4.4,0.5,3v0c0-1.4,1.1-2.5,2.5-2.5h3V5.5z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(72,312) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 6,
    height: 5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(96,312) scale(4.12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3,5.5H0v-5h3c1.4,0,2.5,1.1,2.5,2.5v0C5.5,4.4,4.4,5.5,3,5.5z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(168,312) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 2.5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(312,312) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 2.5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(384,312) scale(4.12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6,5.5H3C1.6,5.5,0.5,4.4,0.5,3v0c0-1.4,1.1-2.5,2.5-2.5h3V5.5z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(408,312) scale(4.12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3,5.5H0v-5h3c1.4,0,2.5,1.1,2.5,2.5v0C5.5,4.4,4.4,5.5,3,5.5z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(528,312) scale(4.12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6,5.5H3C1.6,5.5,0.5,4.4,0.5,3v0c0-1.4,1.1-2.5,2.5-2.5h3V5.5z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(552,312) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 6,
    height: 5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(576,312) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 6,
    height: 5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(600,312) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 6,
    height: 5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(624,312) scale(4.12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3,5.5H0v-5h3c1.4,0,2.5,1.1,2.5,2.5v0C5.5,4.4,4.4,5.5,3,5.5z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(744,312) scale(4.12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6,5.5H3C1.6,5.5,0.5,4.4,0.5,3v0c0-1.4,1.1-2.5,2.5-2.5h3V5.5z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(768,312) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 6,
    height: 5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(792,312) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 6,
    height: 5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(816,312) scale(4.12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3,5.5H0v-5h3c1.4,0,2.5,1.1,2.5,2.5v0C5.5,4.4,4.4,5.5,3,5.5z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(48,336) scale(4.12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6,5.5H3C1.6,5.5,0.5,4.4,0.5,3v0c0-1.4,1.1-2.5,2.5-2.5h3V5.5z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(72,336) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 6,
    height: 5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(96,336) scale(4.12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3,5.5H0v-5h3c1.4,0,2.5,1.1,2.5,2.5v0C5.5,4.4,4.4,5.5,3,5.5z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(144,336) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 2.5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(192,336) scale(4.12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6,5.5H3C1.6,5.5,0.5,4.4,0.5,3v0c0-1.4,1.1-2.5,2.5-2.5h3V5.5z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(216,336) scale(4.12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3,5.5H0v-5h3c1.4,0,2.5,1.1,2.5,2.5v0C5.5,4.4,4.4,5.5,3,5.5z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(360,336) scale(4.12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6,5.5H3C1.6,5.5,0.5,4.4,0.5,3v0c0-1.4,1.1-2.5,2.5-2.5h3V5.5z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(384,336) scale(4.12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3,5.5H0v-5h3c1.4,0,2.5,1.1,2.5,2.5v0C5.5,4.4,4.4,5.5,3,5.5z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(456,336) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 2.5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(552,336) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 2.5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(600,336) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 2.5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(648,336) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 2.5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(744,336) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 2.5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(792,336) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 2.5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(48,360) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 2.5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(120,360) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 2.5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(168,360) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 2.5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(240,360) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 2.5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(312,360) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 2.5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(480,360) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 2.5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(528,360) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 2.5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(576,360) scale(4.12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6,5.5H3C1.6,5.5,0.5,4.4,0.5,3v0c0-1.4,1.1-2.5,2.5-2.5h3V5.5z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(600,360) scale(4.12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3,5.5H0v-5h3c1.4,0,2.5,1.1,2.5,2.5v0C5.5,4.4,4.4,5.5,3,5.5z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(672,360) scale(4.12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6,5.5H3C1.6,5.5,0.5,4.4,0.5,3v0c0-1.4,1.1-2.5,2.5-2.5h3V5.5z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(696,360) scale(4.12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3,5.5H0v-5h3c1.4,0,2.5,1.1,2.5,2.5v0C5.5,4.4,4.4,5.5,3,5.5z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(744,360) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 2.5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(816,360) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 2.5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(144,384) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 2.5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(192,384) scale(4.12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6,5.5H3C1.6,5.5,0.5,4.4,0.5,3v0c0-1.4,1.1-2.5,2.5-2.5h3V5.5z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(216,384) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 6,
    height: 5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(240,384) scale(4.12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3,5.5H0v-5h3c1.4,0,2.5,1.1,2.5,2.5v0C5.5,4.4,4.4,5.5,3,5.5z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(312,384) scale(4.12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6,5.5H3C1.6,5.5,0.5,4.4,0.5,3v0c0-1.4,1.1-2.5,2.5-2.5h3V5.5z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(336,384) scale(4.12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3,5.5H0v-5h3c1.4,0,2.5,1.1,2.5,2.5v0C5.5,4.4,4.4,5.5,3,5.5z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(384,384) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 2.5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(480,384) scale(4.12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6,5.5H3C1.6,5.5,0.5,4.4,0.5,3v0c0-1.4,1.1-2.5,2.5-2.5h3V5.5z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(504,384) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 6,
    height: 5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(528,384) scale(4.12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3,5.5H0v-5h3c1.4,0,2.5,1.1,2.5,2.5v0C5.5,4.4,4.4,5.5,3,5.5z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(576,384) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 2.5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(672,384) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 2.5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(744,384) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 2.5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(792,384) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 2.5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(72,408) scale(4.12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6,5.5H3C1.6,5.5,0.5,4.4,0.5,3v0c0-1.4,1.1-2.5,2.5-2.5h3V5.5z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(96,408) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 6,
    height: 5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(120,408) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 6,
    height: 5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(144,408) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 6,
    height: 5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(168,408) scale(4.12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3,5.5H0v-5h3c1.4,0,2.5,1.1,2.5,2.5v0C5.5,4.4,4.4,5.5,3,5.5z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(216,408) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 2.5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(288,408) scale(4.12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6,5.5H3C1.6,5.5,0.5,4.4,0.5,3v0c0-1.4,1.1-2.5,2.5-2.5h3V5.5z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(312,408) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 6,
    height: 5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(336,408) scale(4.12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3,5.5H0v-5h3c1.4,0,2.5,1.1,2.5,2.5v0C5.5,4.4,4.4,5.5,3,5.5z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(384,408) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 2.5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(456,408) scale(4.12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6,5.5H3C1.6,5.5,0.5,4.4,0.5,3v0c0-1.4,1.1-2.5,2.5-2.5h3V5.5z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(480,408) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 6,
    height: 5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(504,408) scale(4.12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3,5.5H0v-5h3c1.4,0,2.5,1.1,2.5,2.5v0C5.5,4.4,4.4,5.5,3,5.5z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(552,408) scale(4.12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6,5.5H3C1.6,5.5,0.5,4.4,0.5,3v0c0-1.4,1.1-2.5,2.5-2.5h3V5.5z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(576,408) scale(4.12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3,5.5H0v-5h3c1.4,0,2.5,1.1,2.5,2.5v0C5.5,4.4,4.4,5.5,3,5.5z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(624,408) scale(4.12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6,5.5H3C1.6,5.5,0.5,4.4,0.5,3v0c0-1.4,1.1-2.5,2.5-2.5h3V5.5z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(648,408) scale(4.12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3,5.5H0v-5h3c1.4,0,2.5,1.1,2.5,2.5v0C5.5,4.4,4.4,5.5,3,5.5z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(696,408) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 2.5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(768,408) scale(4.12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6,5.5H3C1.6,5.5,0.5,4.4,0.5,3v0c0-1.4,1.1-2.5,2.5-2.5h3V5.5z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(792,408) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 6,
    height: 5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(816,408) scale(4.12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3,5.5H0v-5h3c1.4,0,2.5,1.1,2.5,2.5v0C5.5,4.4,4.4,5.5,3,5.5z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(96,432) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 2.5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(192,432) scale(4.12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6,5.5H3C1.6,5.5,0.5,4.4,0.5,3v0c0-1.4,1.1-2.5,2.5-2.5h3V5.5z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(216,432) scale(4.12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3,5.5H0v-5h3c1.4,0,2.5,1.1,2.5,2.5v0C5.5,4.4,4.4,5.5,3,5.5z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(264,432) scale(4.12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6,5.5H3C1.6,5.5,0.5,4.4,0.5,3v0c0-1.4,1.1-2.5,2.5-2.5h3V5.5z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(288,432) scale(4.12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3,5.5H0v-5h3c1.4,0,2.5,1.1,2.5,2.5v0C5.5,4.4,4.4,5.5,3,5.5z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(336,432) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 2.5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(384,432) scale(4.12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6,5.5H3C1.6,5.5,0.5,4.4,0.5,3v0c0-1.4,1.1-2.5,2.5-2.5h3V5.5z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(408,432) scale(4.12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3,5.5H0v-5h3c1.4,0,2.5,1.1,2.5,2.5v0C5.5,4.4,4.4,5.5,3,5.5z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(456,432) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 2.5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(528,432) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 2.5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(648,432) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 2.5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(696,432) scale(4.12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6,5.5H3C1.6,5.5,0.5,4.4,0.5,3v0c0-1.4,1.1-2.5,2.5-2.5h3V5.5z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(720,432) scale(4.12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3,5.5H0v-5h3c1.4,0,2.5,1.1,2.5,2.5v0C5.5,4.4,4.4,5.5,3,5.5z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(768,432) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 2.5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(816,432) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 2.5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(72,456) scale(4.12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6,5.5H3C1.6,5.5,0.5,4.4,0.5,3v0c0-1.4,1.1-2.5,2.5-2.5h3V5.5z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(96,456) scale(4.12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3,5.5H0v-5h3c1.4,0,2.5,1.1,2.5,2.5v0C5.5,4.4,4.4,5.5,3,5.5z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(144,456) scale(4.12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6,5.5H3C1.6,5.5,0.5,4.4,0.5,3v0c0-1.4,1.1-2.5,2.5-2.5h3V5.5z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(168,456) scale(4.12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3,5.5H0v-5h3c1.4,0,2.5,1.1,2.5,2.5v0C5.5,4.4,4.4,5.5,3,5.5z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(216,456) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 2.5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(264,456) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 2.5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(312,456) scale(4.12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6,5.5H3C1.6,5.5,0.5,4.4,0.5,3v0c0-1.4,1.1-2.5,2.5-2.5h3V5.5z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(336,456) scale(4.12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3,5.5H0v-5h3c1.4,0,2.5,1.1,2.5,2.5v0C5.5,4.4,4.4,5.5,3,5.5z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(384,456) scale(4.12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6,5.5H3C1.6,5.5,0.5,4.4,0.5,3v0c0-1.4,1.1-2.5,2.5-2.5h3V5.5z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(408,456) scale(4.12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3,5.5H0v-5h3c1.4,0,2.5,1.1,2.5,2.5v0C5.5,4.4,4.4,5.5,3,5.5z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(480,456) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 2.5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(528,456) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 2.5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(600,456) scale(4.12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6,5.5H3C1.6,5.5,0.5,4.4,0.5,3v0c0-1.4,1.1-2.5,2.5-2.5h3V5.5z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(624,456) scale(4.12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3,5.5H0v-5h3c1.4,0,2.5,1.1,2.5,2.5v0C5.5,4.4,4.4,5.5,3,5.5z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(672,456) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 2.5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(816,456) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 2.5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(120,480) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 2.5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(192,480) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 2.5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(264,480) scale(4.12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6,5.5H3C1.6,5.5,0.5,4.4,0.5,3v0c0-1.4,1.1-2.5,2.5-2.5h3V5.5z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(288,480) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 6,
    height: 5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(312,480) scale(4.12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3,5.5H0v-5h3c1.4,0,2.5,1.1,2.5,2.5v0C5.5,4.4,4.4,5.5,3,5.5z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(360,480) scale(4.12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6,5.5H3C1.6,5.5,0.5,4.4,0.5,3v0c0-1.4,1.1-2.5,2.5-2.5h3V5.5z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(384,480) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 6,
    height: 5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(408,480) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 6,
    height: 5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(432,480) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 6,
    height: 5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(456,480) scale(4.12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3,5.5H0v-5h3c1.4,0,2.5,1.1,2.5,2.5v0C5.5,4.4,4.4,5.5,3,5.5z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(504,480) scale(4.12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6,5.5H3C1.6,5.5,0.5,4.4,0.5,3v0c0-1.4,1.1-2.5,2.5-2.5h3V5.5z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(528,480) scale(4.12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3,5.5H0v-5h3c1.4,0,2.5,1.1,2.5,2.5v0C5.5,4.4,4.4,5.5,3,5.5z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(576,480) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 2.5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(648,480) scale(4.12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6,5.5H3C1.6,5.5,0.5,4.4,0.5,3v0c0-1.4,1.1-2.5,2.5-2.5h3V5.5z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(672,480) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 6,
    height: 5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(696,480) scale(4.12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3,5.5H0v-5h3c1.4,0,2.5,1.1,2.5,2.5v0C5.5,4.4,4.4,5.5,3,5.5z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(768,480) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 2.5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(72,504) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 2.5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(120,504) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 2.5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(168,504) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 2.5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(216,504) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 2.5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(288,504) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 2.5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(336,504) scale(4.12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6,5.5H3C1.6,5.5,0.5,4.4,0.5,3v0c0-1.4,1.1-2.5,2.5-2.5h3V5.5z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(360,504) scale(4.12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3,5.5H0v-5h3c1.4,0,2.5,1.1,2.5,2.5v0C5.5,4.4,4.4,5.5,3,5.5z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(408,504) scale(4.12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6,5.5H3C1.6,5.5,0.5,4.4,0.5,3v0c0-1.4,1.1-2.5,2.5-2.5h3V5.5z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(432,504) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 6,
    height: 5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(456,504) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 6,
    height: 5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(480,504) scale(4.12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3,5.5H0v-5h3c1.4,0,2.5,1.1,2.5,2.5v0C5.5,4.4,4.4,5.5,3,5.5z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(552,504) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 2.5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(600,504) scale(4.12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6,5.5H3C1.6,5.5,0.5,4.4,0.5,3v0c0-1.4,1.1-2.5,2.5-2.5h3V5.5z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(624,504) scale(4.12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3,5.5H0v-5h3c1.4,0,2.5,1.1,2.5,2.5v0C5.5,4.4,4.4,5.5,3,5.5z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(672,504) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 2.5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(720,504) scale(4.12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6,5.5H3C1.6,5.5,0.5,4.4,0.5,3v0c0-1.4,1.1-2.5,2.5-2.5h3V5.5z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(744,504) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 6,
    height: 5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(768,504) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 6,
    height: 5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(792,504) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 6,
    height: 5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(816,504) scale(4.12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3,5.5H0v-5h3c1.4,0,2.5,1.1,2.5,2.5v0C5.5,4.4,4.4,5.5,3,5.5z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(48,528) scale(4.12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6,5.5H3C1.6,5.5,0.5,4.4,0.5,3v0c0-1.4,1.1-2.5,2.5-2.5h3V5.5z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(72,528) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 6,
    height: 5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(96,528) scale(4.12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3,5.5H0v-5h3c1.4,0,2.5,1.1,2.5,2.5v0C5.5,4.4,4.4,5.5,3,5.5z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(144,528) scale(4.12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6,5.5H3C1.6,5.5,0.5,4.4,0.5,3v0c0-1.4,1.1-2.5,2.5-2.5h3V5.5z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(168,528) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 6,
    height: 5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(192,528) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 6,
    height: 5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(216,528) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 6,
    height: 5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(240,528) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 6,
    height: 5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(264,528) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 6,
    height: 5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(288,528) scale(4.12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3,5.5H0v-5h3c1.4,0,2.5,1.1,2.5,2.5v0C5.5,4.4,4.4,5.5,3,5.5z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(360,528) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 2.5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(408,528) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 2.5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(456,528) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 2.5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(504,528) scale(4.12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6,5.5H3C1.6,5.5,0.5,4.4,0.5,3v0c0-1.4,1.1-2.5,2.5-2.5h3V5.5z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(528,528) scale(4.12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3,5.5H0v-5h3c1.4,0,2.5,1.1,2.5,2.5v0C5.5,4.4,4.4,5.5,3,5.5z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(576,528) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 2.5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(648,528) scale(4.12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6,5.5H3C1.6,5.5,0.5,4.4,0.5,3v0c0-1.4,1.1-2.5,2.5-2.5h3V5.5z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(672,528) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 6,
    height: 5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(696,528) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 6,
    height: 5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(720,528) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 6,
    height: 5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(744,528) scale(4.12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3,5.5H0v-5h3c1.4,0,2.5,1.1,2.5,2.5v0C5.5,4.4,4.4,5.5,3,5.5z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(48,552) scale(4.12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6,5.5H3C1.6,5.5,0.5,4.4,0.5,3v0c0-1.4,1.1-2.5,2.5-2.5h3V5.5z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(72,552) scale(4.12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3,5.5H0v-5h3c1.4,0,2.5,1.1,2.5,2.5v0C5.5,4.4,4.4,5.5,3,5.5z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(144,552) scale(4.12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6,5.5H3C1.6,5.5,0.5,4.4,0.5,3v0c0-1.4,1.1-2.5,2.5-2.5h3V5.5z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(168,552) scale(4.12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3,5.5H0v-5h3c1.4,0,2.5,1.1,2.5,2.5v0C5.5,4.4,4.4,5.5,3,5.5z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(216,552) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 2.5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(264,552) scale(4.12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6,5.5H3C1.6,5.5,0.5,4.4,0.5,3v0c0-1.4,1.1-2.5,2.5-2.5h3V5.5z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(288,552) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 6,
    height: 5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(312,552) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 6,
    height: 5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(336,552) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 6,
    height: 5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(360,552) scale(4.12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3,5.5H0v-5h3c1.4,0,2.5,1.1,2.5,2.5v0C5.5,4.4,4.4,5.5,3,5.5z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(456,552) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 2.5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(504,552) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 2.5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(552,552) scale(4.12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6,5.5H3C1.6,5.5,0.5,4.4,0.5,3v0c0-1.4,1.1-2.5,2.5-2.5h3V5.5z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(576,552) scale(4.12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3,5.5H0v-5h3c1.4,0,2.5,1.1,2.5,2.5v0C5.5,4.4,4.4,5.5,3,5.5z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(624,552) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 2.5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(744,552) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 2.5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(816,552) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 2.5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(48,576) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 2.5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(120,576) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 2.5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(192,576) scale(4.12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6,5.5H3C1.6,5.5,0.5,4.4,0.5,3v0c0-1.4,1.1-2.5,2.5-2.5h3V5.5z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(216,576) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 6,
    height: 5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(240,576) scale(4.12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3,5.5H0v-5h3c1.4,0,2.5,1.1,2.5,2.5v0C5.5,4.4,4.4,5.5,3,5.5z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(288,576) scale(4.12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6,5.5H3C1.6,5.5,0.5,4.4,0.5,3v0c0-1.4,1.1-2.5,2.5-2.5h3V5.5z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(312,576) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 6,
    height: 5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(336,576) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 6,
    height: 5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(360,576) scale(4.12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3,5.5H0v-5h3c1.4,0,2.5,1.1,2.5,2.5v0C5.5,4.4,4.4,5.5,3,5.5z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(504,576) scale(4.12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6,5.5H3C1.6,5.5,0.5,4.4,0.5,3v0c0-1.4,1.1-2.5,2.5-2.5h3V5.5z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(528,576) scale(4.12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3,5.5H0v-5h3c1.4,0,2.5,1.1,2.5,2.5v0C5.5,4.4,4.4,5.5,3,5.5z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(576,576) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 2.5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(720,576) scale(4.12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6,5.5H3C1.6,5.5,0.5,4.4,0.5,3v0c0-1.4,1.1-2.5,2.5-2.5h3V5.5z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(744,576) scale(4.12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3,5.5H0v-5h3c1.4,0,2.5,1.1,2.5,2.5v0C5.5,4.4,4.4,5.5,3,5.5z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(792,576) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 2.5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(48,600) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 2.5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(96,600) scale(4.12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6,5.5H3C1.6,5.5,0.5,4.4,0.5,3v0c0-1.4,1.1-2.5,2.5-2.5h3V5.5z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(120,600) scale(4.12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3,5.5H0v-5h3c1.4,0,2.5,1.1,2.5,2.5v0C5.5,4.4,4.4,5.5,3,5.5z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(168,600) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 2.5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(240,600) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 2.5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(288,600) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 2.5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(336,600) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 2.5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(384,600) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 2.5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(432,600) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 2.5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(480,600) scale(4.12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6,5.5H3C1.6,5.5,0.5,4.4,0.5,3v0c0-1.4,1.1-2.5,2.5-2.5h3V5.5z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(504,600) scale(4.12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3,5.5H0v-5h3c1.4,0,2.5,1.1,2.5,2.5v0C5.5,4.4,4.4,5.5,3,5.5z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(552,600) scale(4.12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6,5.5H3C1.6,5.5,0.5,4.4,0.5,3v0c0-1.4,1.1-2.5,2.5-2.5h3V5.5z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(576,600) scale(4.12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3,5.5H0v-5h3c1.4,0,2.5,1.1,2.5,2.5v0C5.5,4.4,4.4,5.5,3,5.5z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(624,600) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 2.5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(720,600) scale(4.12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6,5.5H3C1.6,5.5,0.5,4.4,0.5,3v0c0-1.4,1.1-2.5,2.5-2.5h3V5.5z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(744,600) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 6,
    height: 5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(768,600) scale(4.12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3,5.5H0v-5h3c1.4,0,2.5,1.1,2.5,2.5v0C5.5,4.4,4.4,5.5,3,5.5z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(48,624) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 2.5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(96,624) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 2.5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(144,624) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 2.5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(192,624) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 2.5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(264,624) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 2.5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(336,624) scale(4.12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6,5.5H3C1.6,5.5,0.5,4.4,0.5,3v0c0-1.4,1.1-2.5,2.5-2.5h3V5.5z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(360,624) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 6,
    height: 5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(384,624) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 6,
    height: 5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(408,624) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 6,
    height: 5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(432,624) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 6,
    height: 5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(456,624) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 6,
    height: 5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(480,624) scale(4.12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3,5.5H0v-5h3c1.4,0,2.5,1.1,2.5,2.5v0C5.5,4.4,4.4,5.5,3,5.5z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(576,624) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 2.5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(624,624) scale(4.12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6,5.5H3C1.6,5.5,0.5,4.4,0.5,3v0c0-1.4,1.1-2.5,2.5-2.5h3V5.5z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(648,624) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 6,
    height: 5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(672,624) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 6,
    height: 5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(696,624) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 6,
    height: 5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(720,624) scale(4.12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3,5.5H0v-5h3c1.4,0,2.5,1.1,2.5,2.5v0C5.5,4.4,4.4,5.5,3,5.5z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(792,624) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 2.5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(240,648) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 2.5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(288,648) scale(4.12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6,5.5H3C1.6,5.5,0.5,4.4,0.5,3v0c0-1.4,1.1-2.5,2.5-2.5h3V5.5z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(312,648) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 6,
    height: 5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(336,648) scale(4.12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3,5.5H0v-5h3c1.4,0,2.5,1.1,2.5,2.5v0C5.5,4.4,4.4,5.5,3,5.5z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(432,648) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 2.5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(480,648) scale(4.12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6,5.5H3C1.6,5.5,0.5,4.4,0.5,3v0c0-1.4,1.1-2.5,2.5-2.5h3V5.5z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(504,648) scale(4.12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3,5.5H0v-5h3c1.4,0,2.5,1.1,2.5,2.5v0C5.5,4.4,4.4,5.5,3,5.5z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(576,648) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 2.5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(624,648) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 2.5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(720,648) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 2.5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(768,648) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 2.5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(816,648) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 2.5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(264,672) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 2.5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(336,672) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 2.5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(432,672) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 2.5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(480,672) scale(4.12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6,5.5H3C1.6,5.5,0.5,4.4,0.5,3v0c0-1.4,1.1-2.5,2.5-2.5h3V5.5z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(504,672) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 6,
    height: 5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(528,672) scale(4.12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3,5.5H0v-5h3c1.4,0,2.5,1.1,2.5,2.5v0C5.5,4.4,4.4,5.5,3,5.5z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(576,672) scale(4.12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6,5.5H3C1.6,5.5,0.5,4.4,0.5,3v0c0-1.4,1.1-2.5,2.5-2.5h3V5.5z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(600,672) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 6,
    height: 5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(624,672) scale(4.12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3,5.5H0v-5h3c1.4,0,2.5,1.1,2.5,2.5v0C5.5,4.4,4.4,5.5,3,5.5z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(672,672) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 2.5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(720,672) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 2.5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(768,672) scale(4.12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6,5.5H3C1.6,5.5,0.5,4.4,0.5,3v0c0-1.4,1.1-2.5,2.5-2.5h3V5.5z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(792,672) scale(4.12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3,5.5H0v-5h3c1.4,0,2.5,1.1,2.5,2.5v0C5.5,4.4,4.4,5.5,3,5.5z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(264,696) scale(4.12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6,5.5H3C1.6,5.5,0.5,4.4,0.5,3v0c0-1.4,1.1-2.5,2.5-2.5h3V5.5z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(288,696) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 6,
    height: 5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(312,696) scale(4.12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3,5.5H0v-5h3c1.4,0,2.5,1.1,2.5,2.5v0C5.5,4.4,4.4,5.5,3,5.5z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(408,696) scale(4.12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6,5.5H3C1.6,5.5,0.5,4.4,0.5,3v0c0-1.4,1.1-2.5,2.5-2.5h3V5.5z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(432,696) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 6,
    height: 5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(456,696) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 6,
    height: 5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(480,696) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 6,
    height: 5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(504,696) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 6,
    height: 5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(528,696) scale(4.12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3,5.5H0v-5h3c1.4,0,2.5,1.1,2.5,2.5v0C5.5,4.4,4.4,5.5,3,5.5z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(600,696) scale(4.12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6,5.5H3C1.6,5.5,0.5,4.4,0.5,3v0c0-1.4,1.1-2.5,2.5-2.5h3V5.5z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(624,696) scale(4.12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3,5.5H0v-5h3c1.4,0,2.5,1.1,2.5,2.5v0C5.5,4.4,4.4,5.5,3,5.5z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(720,696) scale(4.12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6,5.5H3C1.6,5.5,0.5,4.4,0.5,3v0c0-1.4,1.1-2.5,2.5-2.5h3V5.5z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(744,696) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 6,
    height: 5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(768,696) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 6,
    height: 5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(792,696) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 6,
    height: 5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(816,696) scale(4.12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3,5.5H0v-5h3c1.4,0,2.5,1.1,2.5,2.5v0C5.5,4.4,4.4,5.5,3,5.5z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(240,720) scale(4.12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6,5.5H3C1.6,5.5,0.5,4.4,0.5,3v0c0-1.4,1.1-2.5,2.5-2.5h3V5.5z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(264,720) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 6,
    height: 5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(288,720) scale(4.12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3,5.5H0v-5h3c1.4,0,2.5,1.1,2.5,2.5v0C5.5,4.4,4.4,5.5,3,5.5z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(336,720) scale(4.12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6,5.5H3C1.6,5.5,0.5,4.4,0.5,3v0c0-1.4,1.1-2.5,2.5-2.5h3V5.5z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(360,720) scale(4.12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3,5.5H0v-5h3c1.4,0,2.5,1.1,2.5,2.5v0C5.5,4.4,4.4,5.5,3,5.5z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(456,720) scale(4.12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6,5.5H3C1.6,5.5,0.5,4.4,0.5,3v0c0-1.4,1.1-2.5,2.5-2.5h3V5.5z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(480,720) scale(4.12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3,5.5H0v-5h3c1.4,0,2.5,1.1,2.5,2.5v0C5.5,4.4,4.4,5.5,3,5.5z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(552,720) scale(4.12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6,5.5H3C1.6,5.5,0.5,4.4,0.5,3v0c0-1.4,1.1-2.5,2.5-2.5h3V5.5z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(576,720) scale(4.12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3,5.5H0v-5h3c1.4,0,2.5,1.1,2.5,2.5v0C5.5,4.4,4.4,5.5,3,5.5z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(624,720) scale(4.12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6,5.5H3C1.6,5.5,0.5,4.4,0.5,3v0c0-1.4,1.1-2.5,2.5-2.5h3V5.5z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(648,720) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 6,
    height: 5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(672,720) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 6,
    height: 5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(696,720) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 6,
    height: 5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(720,720) scale(4.12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3,5.5H0v-5h3c1.4,0,2.5,1.1,2.5,2.5v0C5.5,4.4,4.4,5.5,3,5.5z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(792,720) scale(4.12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6,5.5H3C1.6,5.5,0.5,4.4,0.5,3v0c0-1.4,1.1-2.5,2.5-2.5h3V5.5z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(816,720) scale(4.12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3,5.5H0v-5h3c1.4,0,2.5,1.1,2.5,2.5v0C5.5,4.4,4.4,5.5,3,5.5z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(240,744) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 2.5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(312,744) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 2.5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(384,744) scale(4.12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6,5.5H3C1.6,5.5,0.5,4.4,0.5,3v0c0-1.4,1.1-2.5,2.5-2.5h3V5.5z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(408,744) scale(4.12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3,5.5H0v-5h3c1.4,0,2.5,1.1,2.5,2.5v0C5.5,4.4,4.4,5.5,3,5.5z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(480,744) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 2.5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(528,744) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 2.5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(648,744) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 2.5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(720,744) scale(4.12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6,5.5H3C1.6,5.5,0.5,4.4,0.5,3v0c0-1.4,1.1-2.5,2.5-2.5h3V5.5z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(744,744) scale(4.12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3,5.5H0v-5h3c1.4,0,2.5,1.1,2.5,2.5v0C5.5,4.4,4.4,5.5,3,5.5z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(792,744) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 2.5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(240,768) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 2.5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(312,768) scale(4.12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6,5.5H3C1.6,5.5,0.5,4.4,0.5,3v0c0-1.4,1.1-2.5,2.5-2.5h3V5.5z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(336,768) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 6,
    height: 5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(360,768) scale(4.12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3,5.5H0v-5h3c1.4,0,2.5,1.1,2.5,2.5v0C5.5,4.4,4.4,5.5,3,5.5z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(408,768) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 2.5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(528,768) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 2.5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(576,768) scale(4.12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6,5.5H3C1.6,5.5,0.5,4.4,0.5,3v0c0-1.4,1.1-2.5,2.5-2.5h3V5.5z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(600,768) scale(4.12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3,5.5H0v-5h3c1.4,0,2.5,1.1,2.5,2.5v0C5.5,4.4,4.4,5.5,3,5.5z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(648,768) scale(4.12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6,5.5H3C1.6,5.5,0.5,4.4,0.5,3v0c0-1.4,1.1-2.5,2.5-2.5h3V5.5z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(672,768) scale(4.12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3,5.5H0v-5h3c1.4,0,2.5,1.1,2.5,2.5v0C5.5,4.4,4.4,5.5,3,5.5z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(336,792) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 2.5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(456,792) scale(4.12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6,5.5H3C1.6,5.5,0.5,4.4,0.5,3v0c0-1.4,1.1-2.5,2.5-2.5h3V5.5z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(480,792) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 6,
    height: 5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(504,792) scale(4.12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3,5.5H0v-5h3c1.4,0,2.5,1.1,2.5,2.5v0C5.5,4.4,4.4,5.5,3,5.5z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(552,792) scale(4.12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6,5.5H3C1.6,5.5,0.5,4.4,0.5,3v0c0-1.4,1.1-2.5,2.5-2.5h3V5.5z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(576,792) scale(4.12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3,5.5H0v-5h3c1.4,0,2.5,1.1,2.5,2.5v0C5.5,4.4,4.4,5.5,3,5.5z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(648,792) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 2.5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(696,792) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 2.5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(744,792) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 2.5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(264,816) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 2.5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(336,816) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 2.5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(384,816) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 2.5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(432,816) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 2.5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(528,816) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 2.5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(576,816) scale(4.12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6,5.5H3C1.6,5.5,0.5,4.4,0.5,3v0c0-1.4,1.1-2.5,2.5-2.5h3V5.5z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(600,816) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 6,
    height: 5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(624,816) scale(4.12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3,5.5H0v-5h3c1.4,0,2.5,1.1,2.5,2.5v0C5.5,4.4,4.4,5.5,3,5.5z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(768,816) scale(4.12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6,5.5H3C1.6,5.5,0.5,4.4,0.5,3v0c0-1.4,1.1-2.5,2.5-2.5h3V5.5z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(792,816) scale(4.12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3,5.5H0v-5h3c1.4,0,2.5,1.1,2.5,2.5v0C5.5,4.4,4.4,5.5,3,5.5z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(48,48)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "scale(12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.5,14h5.1C12,14,14,12,14,9.6V4.5C14,2,12,0,9.5,0H4.4C2,0,0,2,0,4.4v5.1C0,12,2,14,4.5,14z M12,4.8v4.4 c0,1.5-1.3,2.8-2.8,2.8H4.8C3.2,12,2,10.8,2,9.2V4.8C2,3.3,3.3,2,4.8,2h4.4C10.8,2,12,3.2,12,4.8z"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(672,48)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "scale(12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.5,14h5.1C12,14,14,12,14,9.6V4.5C14,2,12,0,9.5,0H4.4C2,0,0,2,0,4.4v5.1C0,12,2,14,4.5,14z M12,4.8v4.4 c0,1.5-1.3,2.8-2.8,2.8H4.8C3.2,12,2,10.8,2,9.2V4.8C2,3.3,3.3,2,4.8,2h4.4C10.8,2,12,3.2,12,4.8z"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(48,672)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "scale(12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.5,14h5.1C12,14,14,12,14,9.6V4.5C14,2,12,0,9.5,0H4.4C2,0,0,2,0,4.4v5.1C0,12,2,14,4.5,14z M12,4.8v4.4 c0,1.5-1.3,2.8-2.8,2.8H4.8C3.2,12,2,10.8,2,9.2V4.8C2,3.3,3.3,2,4.8,2h4.4C10.8,2,12,3.2,12,4.8z"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(96,96)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "scale(12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6,1.7v2.7C6,5.2,5.2,6,4.3,6H1.7C0.7,6,0,5.3,0,4.3V1.7C0,0.8,0.8,0,1.7,0h2.7C5.3,0,6,0.7,6,1.7z"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(720,96)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "scale(12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6,1.7v2.7C6,5.2,5.2,6,4.3,6H1.7C0.7,6,0,5.3,0,4.3V1.7C0,0.8,0.8,0,1.7,0h2.7C5.3,0,6,0.7,6,1.7z"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(96,720)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "scale(12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6,1.7v2.7C6,5.2,5.2,6,4.3,6H1.7C0.7,6,0,5.3,0,4.3V1.7C0,0.8,0.8,0,1.7,0h2.7C5.3,0,6,0.7,6,1.7z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQr);
export default __webpack_public_path__ + "static/media/qr.48b809e18e9e8eb4aa16022bc21665e4.svg";
export { ForwardRef as ReactComponent };